var _rect, _rect2, _ellipse, _path, _rect3, _ellipse2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _circle, _path15, _path16, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _circle2, _path17, _path18, _path19, _path20, _ellipse11, _ellipse12, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgG7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 110,
    viewBox: "0 0 135 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 132.199,
    height: 107.374,
    rx: 9,
    fill: "#55CC80",
    stroke: "#28ADE0",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53.2236,
    y: 23.5752,
    width: 5.03864,
    height: 10.0773,
    fill: "#70544B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.4916,
    cy: 20.0464,
    rx: 6.80217,
    ry: 6.04637,
    fill: "#70544B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0377 14.4447C47.5741 16.2379 47.1456 23.5548 52.3985 25.3609L53.2975 25.6701V29.6603V33.6507H55.9537H58.6098V29.6161V25.5816L59.3541 25.2156C66.7748 21.5667 61.055 11.8132 53.0377 14.4447ZM58.3442 15.4871C62.8912 17.4474 62.9653 22.4504 58.477 24.463C53.6357 26.6339 48.096 22.6129 49.99 18.3026C51.2314 15.4777 55.211 14.1365 58.3442 15.4871ZM57.5474 29.2308V32.6405H55.9537H54.36V29.3703V26.1001L55.7544 26.0073C56.5215 25.9563 57.2386 25.8935 57.3482 25.8679C57.4577 25.8422 57.5474 27.3555 57.5474 29.2308Z",
    fill: "#20312D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5.03864,
    height: 10.0773,
    transform: "matrix(-1 0 0 1 78.417 23.5752)",
    fill: "#70544B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.80217,
    cy: 6.04637,
    rx: 6.80217,
    ry: 6.04637,
    transform: "matrix(-1 0 0 1 82.9521 14)",
    fill: "#70544B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.6039 14.4447C84.0675 16.2379 84.496 23.5548 79.2431 25.3609L78.3441 25.6701V29.6603V33.6507H75.6879H73.0318V29.6161V25.5816L72.2875 25.2156C64.8668 21.5667 70.5866 11.8132 78.6039 14.4447ZM73.2974 15.4871C68.7504 17.4474 68.6763 22.4504 73.1646 24.463C78.0059 26.6339 83.5456 22.6129 81.6516 18.3026C80.4102 15.4777 76.4306 14.1365 73.2974 15.4871ZM74.0942 29.2308V32.6405H75.6879H77.2816V29.3703V26.1001L75.8872 26.0073C75.1201 25.9563 74.4031 25.8935 74.2934 25.8679C74.1839 25.8422 74.0942 27.3555 74.0942 29.2308Z",
    fill: "#20312D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.91 30.0579C52.6555 30.6695 46.0175 33.3749 43.9028 35.7667L43.4412 36.2888L35.7179 33.6833C25.2293 30.1451 25.9761 30.1877 24.9157 33.0686C22.0436 40.8715 26.06 47.325 35.1112 49.4512C36.4606 49.7682 37.6162 50.0663 37.6793 50.1135C37.7422 50.1607 37.8776 51.7534 37.9802 53.6527C38.2366 58.403 39.2134 62.9346 41.5198 70.0758C48.1283 90.5368 53.44 96.1559 66.1489 96.1301C77.3965 96.1073 82.7502 91.2975 88.0007 76.4978C92.4842 63.8604 93.8174 58.7502 93.8703 54.0027C93.8806 53.0776 93.9655 51.8159 94.0592 51.1987L94.2294 50.0764L95.8662 49.7476C105.617 47.7888 109.73 41.7651 107.069 33.342C106.061 30.1497 106.634 30.1296 95.7214 33.7383L88.399 36.1596L87.0329 35.1394C80.9907 30.6267 69.7985 28.6737 57.91 30.0579Z",
    fill: "#20312D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4338 30.9129C39.5978 32.5558 34.2847 45.6981 43.0784 71.3709C49.5101 90.1485 54.3176 95.114 66.0158 95.0617C78.0392 95.0081 82.5782 89.6656 89.9507 66.8897C98.3725 40.872 87.9234 28.5534 59.4338 30.9129ZM25.6695 33.8343C23.5009 41.1392 26.6827 46.0669 34.9234 48.1663C38.0652 48.9665 38.0224 48.9695 38.0224 47.9574C38.0224 45.7558 39.6229 41.1389 41.2026 38.783C41.8154 37.8694 42.2735 37.0788 42.221 37.0259C42.0271 36.8323 27.0477 31.903 26.6522 31.903C26.3602 31.903 26.0786 32.4559 25.6695 33.8343ZM96.9445 34.409C88.1364 37.3441 88.9701 36.8704 90.0732 38.3156C91.8382 40.628 93.498 45.2438 93.5029 47.8539C93.5051 48.9883 93.5557 48.9957 96.5248 48.2837C104.592 46.3502 108.118 41.0837 106.057 34.0465C105.296 31.4487 105.9 31.4244 96.9445 34.409Z",
    fill: "#F3BD3E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0319 61.0188C89.3707 60.6949 92.8186 58.2475 92.3148 60.0111C93.1849 61.5009 90.8823 64.8197 90.0927 66.9753C89.3139 69.1302 89.4046 72.9221 88.0319 72.3558C86.6592 71.7895 83.3565 66.7825 83.2839 64.5867C83.222 62.3902 85.7775 61.5642 88.0319 61.0188Z",
    fill: "#70544B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.511 42.4909C61.5303 44.3455 58.3174 43.0726 54.9665 40.0982C52.1927 37.6361 50.183 33.1726 51.4391 31.2804C54.6869 31.2805 62.2094 28.7324 62.4956 30.3979C62.7818 32.0635 68.3762 40.0858 64.511 42.4909Z",
    fill: "#70544B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6559 44.1534C93.2604 45.9971 93.4639 48.2896 92.2414 49.2739C91.0189 50.2581 89.359 48.9821 87.7066 47.7623C86.0543 46.5562 85.6717 44.4425 86.1956 42.7236C86.7195 41.0047 88.2413 39.0861 89.9743 39.197C91.7073 39.3217 92.0514 42.3098 92.6559 44.1534Z",
    fill: "#70544B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8479 54.699C44.3907 56.5205 43.1483 59.6567 43.1483 59.6567C43.1483 59.6567 41.3436 62.7063 39.8599 61.5011C39.4067 59.6567 37.8905 55.2512 38.3609 53.553C38.8314 51.8548 38.9386 51.193 40.4946 51.3026C42.0506 51.4259 43.3051 52.8775 43.8479 54.699Z",
    fill: "#70544B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8003 30.4328C74.8945 30.6275 78.682 30.9943 77.4714 33.0942C76.2608 35.1942 75.7451 41.2112 72.8009 42.3312C69.9607 43.4116 69.7616 39.341 68.348 37.0397C66.8839 34.6562 64.8415 31.8256 65.5799 30.4334C66.3183 29.0411 70.6925 30.2321 72.8003 30.4328Z",
    fill: "#70544B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1079 34.1399C80.2972 33.4844 80.1142 32.7291 80.7787 32.5268C81.4498 32.3263 82.6513 32.6335 83.2569 33.2007C87.9909 35.6656 85.8409 36.3604 84.7152 37.9326C83.6615 39.4041 80.7804 38.6516 80.1083 38.4369C77.4098 36.6734 79.6425 35.7522 80.1079 34.1399Z",
    fill: "#70544B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6311 36.4302C44.8788 35.0808 46.5491 34.1361 47.9919 34.8692C49.4412 35.6156 50.6631 38.0398 50.4287 39.9353C50.183 41.8364 48.481 43.2089 46.62 43.3556C44.7524 43.489 41.2509 42.6666 40.6558 41.2406C40.0607 39.8147 42.372 37.7852 43.6311 36.4302Z",
    fill: "#70544B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4304 65.2415C42.1784 64.1353 43.2897 63.4626 44.4475 64.3343C45.6118 65.2194 46.8226 67.649 46.8917 69.3968C46.9532 71.1484 45.8732 72.2183 44.5192 72.1183C43.1588 72.005 42.6607 71.1363 42.0396 69.7229C41.4186 68.3095 40.6748 66.3515 41.4304 65.2415Z",
    fill: "#70544B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.385 68.8911C55.7891 69.6836 52.1111 71.089 48.3686 73.4826C44.229 76.1302 44.0006 76.7012 45.5155 80.6122C53.6057 101.498 78.6777 101.242 86.2679 80.1965C87.5006 76.7788 87.3013 76.1222 84.3812 73.9809C78.1362 69.4015 68.8488 67.4316 60.385 68.8911Z",
    fill: "#20312D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0432 70.1456C54.9384 71.0205 45.0832 75.8553 45.693 78.1666C51.4047 99.8156 78.1653 101.421 85.3081 80.0263C86.2325 77.4249 86.2291 77.367 85.0906 76.3475C79.6448 71.4702 70.7412 69.0743 62.0432 70.1456Z",
    fill: "#FFF2C5"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.833,
    cy: 60.103,
    rx: 6.04637,
    ry: 6.80217,
    transform: "rotate(-10 56.833 60.103)",
    fill: "#20312D"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.8277,
    cy: 60.1029,
    rx: 5.03864,
    ry: 5.79444,
    transform: "rotate(-10 56.8277 60.1029)",
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.0452,
    cy: 60.2815,
    rx: 3.94965,
    ry: 4.3885,
    transform: "rotate(-10 57.0452 60.2815)",
    fill: "#70544B"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.9562,
    cy: 60.3308,
    rx: 2.51932,
    ry: 3.02319,
    transform: "rotate(-10 56.9562 60.3308)",
    fill: "#20312D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.2187,
    cy: 57.4705,
    r: 1.76353,
    transform: "rotate(-10 57.2187 57.4705)",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0306 49.7746C57.8365 51.1581 55.9544 50.4634 54.5566 50.6288C53.1588 50.7942 51.102 52.274 50.5971 50.8108C50.075 49.298 52.5158 49.192 54.2673 48.9883C55.7587 48.8148 58.2393 48.2877 58.0306 49.7746Z",
    fill: "#20312D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2164 49.2706C74.4106 50.6542 76.2927 49.9595 77.6905 50.1249C79.0883 50.2903 81.145 51.7701 81.65 50.3069C82.1721 48.7941 79.7313 48.688 77.9798 48.4843C76.4884 48.3109 74.0078 47.7838 74.2164 49.2706Z",
    fill: "#20312D"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.0497,
    cy: 60.0427,
    rx: 6.04637,
    ry: 6.80217,
    transform: "rotate(10 75.0497 60.0427)",
    fill: "#20312D"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.0448,
    cy: 60.0403,
    rx: 5.03864,
    ry: 5.79444,
    transform: "rotate(10 75.0448 60.0403)",
    fill: "white"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.1891,
    cy: 60.2831,
    rx: 3.94965,
    ry: 4.3885,
    transform: "rotate(10 75.1891 60.2831)",
    fill: "#70544B"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.0879,
    cy: 60.2975,
    rx: 2.51932,
    ry: 3.02319,
    transform: "rotate(10 75.0879 60.2975)",
    fill: "#20312D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.3123,
    cy: 57.7002,
    r: 1.76353,
    transform: "rotate(10 76.3123 57.7002)",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4551 34.9929C26.1989 35.6297 25.7584 36.8967 26.1637 38.7076C27.3026 43.7969 32.8269 44.8015 36.5956 40.6046L37.8975 39.1548L38.8801 39.5015C39.9588 39.8821 40.3178 39.7918 40.3052 39.143C40.2915 38.438 32.0973 35.0872 29.4669 34.711C28.6304 34.5913 28.1011 34.6655 27.4551 34.9929Z",
    fill: "#20312D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4311 36.1481C26.3869 37.2641 27.4861 40.6639 29.2222 41.6876C31.1669 42.8343 34.2263 42.0534 36.1744 39.913C37.5756 38.3735 37.6669 38.5144 34.4805 37.2965C29.8937 35.5433 28.248 35.2753 27.4311 36.1481Z",
    fill: "#FFF2C5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.232 35.5882C105.457 36.2824 105.839 37.5684 105.35 39.3587C103.977 44.3898 98.4114 45.1377 94.8405 40.7709L93.607 39.2624L92.6092 39.5633C91.514 39.8936 91.1594 39.7867 91.2021 39.1393C91.2484 38.4357 99.5898 35.4676 102.235 35.2134C103.076 35.1326 103.602 35.2312 104.232 35.5882Z",
    fill: "#20312D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.202 36.743C105.194 37.9061 103.938 41.2515 102.157 42.1937C100.161 43.2493 97.1403 42.3276 95.2931 40.0994C93.9644 38.4967 93.8667 38.6332 97.1064 37.564C101.77 36.0249 103.426 35.8333 104.202 36.743Z",
    fill: "#FFF2C5"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.7648,
    cy: 79.5027,
    rx: 2.51932,
    ry: 3.02319,
    transform: "rotate(-10 60.7648 79.5027)",
    fill: "#20312D"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.3291,
    cy: 79.39,
    rx: 2.51932,
    ry: 3.02319,
    transform: "rotate(-170 71.3291 79.39)",
    fill: "#20312D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1019 89.5798C63.7342 89.5798 61.4652 88.728 59.9854 87.3341C59.6894 87.0243 59.6894 86.4822 60.084 86.2499C60.4786 86.0176 61.1692 86.0176 61.4652 86.3274C62.649 87.4115 64.3262 88.031 66.1019 88.031C67.8777 88.031 69.5548 87.4115 70.64 86.3274C70.936 86.0176 71.6265 85.9402 72.0212 86.2499C72.4158 86.4822 72.5144 87.0243 72.1198 87.3341C70.7387 88.728 68.4696 89.5798 66.1019 89.5798Z",
    fill: "#20312D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7195 29.8505C39.9503 31.933 33.851 44.592 40.1323 66.3523C46.7441 89.2572 52.7597 96.1871 66.019 96.1737C79.1094 96.1604 84.2376 89.994 91.8076 65.1641C94.7079 55.651 94.5849 45.9517 91.489 40.0718C87.258 32.0357 73.8086 27.9648 57.7195 29.8505ZM74.4368 31.2521C83.2509 32.8098 89.2392 36.9382 91.3188 42.8908C94.2232 51.2045 92.86 60.071 85.8072 78.7377C81.1534 91.055 74.194 96.1187 63.423 95.0246C52.9152 93.9573 47.4055 86.746 41.4203 66.226C35.6422 46.4169 39.6965 35.4667 54.1542 31.833C59.0654 30.5988 69.1121 30.3109 74.4368 31.2521Z",
    fill: "#20312D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG7);
export default __webpack_public_path__ + "static/media/g7.4c6db8aeaa2355d7c28c29a15eb02d94.svg";
export { ForwardRef as ReactComponent };